module.exports = __webpack_public_path__ + "static/media/f_hairstyle_straight_short_front_shadow.48d2c127.png";